/// <amd-module name="VSSUI/Components/PersonaCard/PersonaCardHeaderElement" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";

import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { VssPersona } from "VSSUI/VssPersona";
import { HeaderElementProps } from "./PersonaCard.Props";

/** @deprecated */
export class PersonaCardHeaderElement extends React.Component<HeaderElementProps> {
    private _personaElement: HTMLDivElement;

    public componentDidMount(): void {
        this.props.setFocus && this.props.setFocus();
    }

    public componentDidUpdate(): void {
        this.props.setFocus && this.props.setFocus();
    }

    // Render
    public render(): JSX.Element {
        if (!this.props.identity) {
            // Identity is null in the case of previous
            return null;
        }

        const identity = this.props.identity;
        const personaData = {
            imageUrl: identity.image,
            primaryText: identity.displayName,
            secondaryText: identity.jobTitle,
            tertiaryText: identity.department
        };

        return (
            <div
                className="go-back-persona-wrapper"
                onClick={this.props.onClickFunction}
                aria-label={Resources.PeoplePickerHeaderButtonLabel}
                ref={element => {
                    this._personaElement = element;
                }}
                data-is-focusable={true}
                role="button"
            >
                <div>
                    <VssIcon iconType={VssIconType.fabric} iconName="ChevronLeft" />
                </div>
                <div className="go-back-positioning flex-row">
                    <VssPersona
                        displayName={personaData.primaryText}
                        imageUrl={ personaData.imageUrl}
                        className="go-back-persona"
                        size="small"
                        suppressPersonaCard={true}
                    />
                    <div className="flex-column flex-grow persona-card-name">
                        <div className="persona-header-text-primary">{personaData.primaryText}</div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Sets the focus on this header.
     */
    public setFocus() {
        if (this._personaElement) {
            this._personaElement.focus();
        }
    }
}
